/**
 * converts String (minutes) into Array with hours and Minutes
 * @param {any} dateIn String
 * @returns {any}
 */
export const convertMinutes = (dateIn: any): any[] => {
  const time = [];

  const hours = Math.floor(dateIn / 60);
  const minutes = dateIn % 60;

  time.push(hours);
  time.push(minutes);

  return time;
};
